export default "__VITE_PUBLIC_ASSET__287e52aa__"